import { QuestionCircleOutlined } from "@ant-design/icons/lib/icons";
import { Select } from "antd";
import React, { useCallback, useState } from "react";

import { Tooltip } from "@skydio/rivet-ui";

// TODO (david.taylor): This component uses antd because the only place it's used is stuck on antd (uses a form).
// Once rivet-ui is 1.0 & UserProfile.tsx gets moved to use rivet, we should update this to use rivet as well.

interface OneTimePasswordEnabledSelectionProps {
  initialState: boolean;
  onChange: (value: boolean) => void;
}

const OneTimePasswordEnabledSelection = ({
  initialState,
  onChange,
}: OneTimePasswordEnabledSelectionProps) => {
  const [loginEnabled, setLoginEnabled] = useState(initialState);

  const handleChange = useCallback(
    (value: boolean) => {
      setLoginEnabled(value);
      onChange(value);
    },
    [onChange]
  );

  return (
    <div className="flex items-center gap-2">
      <Tooltip
        showArrow={true}
        color="default"
        closeDelay={350}
        content="Turning off one-time password logins is currently disabled."
      >
        <QuestionCircleOutlined />
      </Tooltip>
      <Select
        className="w-32"
        value={loginEnabled}
        onChange={handleChange}
        disabled={true} // We currently don't support disabling OTP logins
      >
        <Select.Option value={true}>Enabled</Select.Option>
        <Select.Option value={false}>Disabled</Select.Option>
      </Select>
    </div>
  );
};

export default OneTimePasswordEnabledSelection;
